import React from "react";
import { motion } from "framer-motion";
import { FaShieldAlt, FaTools, FaWhatsapp } from "react-icons/fa";
import Navbar from "../components/Navbar";

const WarrantyPolicy = () => {
  const whatsappNumber = "+923001234567"; // replace with your actual WhatsApp number

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center px-4 py-10 mt-5">
        <Navbar/>
      <motion.div
        className="w-full max-w-5xl bg-white rounded-2xl shadow-xl p-8 md:p-12"
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <h1 className="text-4xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-purple-800 to-pink-500 text-center mb-8">
          Warranty Policy
        </h1>

        {/* Warranty Overview */}
        <div className="flex flex-col md:flex-row items-start md:items-center mb-10 space-y-6 md:space-y-0 md:space-x-8">
          <FaShieldAlt className="text-purple-700 text-5xl" />
          <div>
            <h2 className="text-2xl font-bold text-gray-800 mb-2">
              Warranty Coverage 🛡️
            </h2>
            <p className="text-gray-600 leading-relaxed">
              All our products come with a 
              <span className="font-semibold text-gray-800"> limited warranty of 6 months</span> 
              from the date of purchase, unless stated otherwise.
              <br /><br />
              The warranty covers defects in materials and workmanship under normal use. 
              If a product fails due to a manufacturing defect, we will repair or replace it at no additional cost.
            </p>
          </div>
        </div>

        {/* What’s Not Covered */}
        <div className="flex flex-col md:flex-row items-start md:items-center mb-10 space-y-6 md:space-y-0 md:space-x-8">
          <FaTools className="text-pink-600 text-5xl" />
          <div>
            <h2 className="text-2xl font-bold text-gray-800 mb-2">
              What’s Not Covered ⚙️
            </h2>
            <p className="text-gray-600 leading-relaxed">
              This warranty does not cover damages caused by:
              <ul className="list-disc list-inside mt-2">
                <li>Improper installation or misuse</li>
                <li>Accidents, drops, or water damage</li>
                <li>Unauthorized repairs or modifications</li>
                <li>Normal wear and tear over time</li>
              </ul>
              <br />
              Products that are found to be damaged due to external causes will not be eligible for warranty claims.
            </p>
          </div>
        </div>

        {/* Claim Process */}
        <div className="flex flex-col md:flex-row items-start md:items-center mb-10 space-y-6 md:space-y-0 md:space-x-8">
          <FaShieldAlt className="text-green-600 text-5xl" />
          <div>
            <h2 className="text-2xl font-bold text-gray-800 mb-2">
              How to Claim Your Warranty 📝
            </h2>
            <p className="text-gray-600 leading-relaxed">
              To initiate a warranty claim, please provide your order number, proof of purchase, and product details.
              <br /><br />
              You can reach us through WhatsApp or email. Once verified, our support team will guide you through the replacement or repair process.
            </p>
          </div>
        </div>

        {/* WhatsApp Contact */}
        <motion.a
          href={`https://wa.me/${whatsappNumber.replace("+", "")}`}
          target="_blank"
          rel="noopener noreferrer"
          whileHover={{ scale: 1.05 }}
          className="flex items-center justify-center space-x-2 bg-green-500 text-white py-3 px-6 rounded-full shadow-lg mx-auto w-fit transition-transform"
        >
          <FaWhatsapp className="text-2xl" />
          <span className="font-semibold">Chat with us on WhatsApp</span>
        </motion.a>
      </motion.div>
    </div>
  );
};

export default WarrantyPolicy;
